import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './redux/store';
import App from './components/App/App';
import { CssVarsProvider, extendTheme, StyledEngineProvider } from '@mui/joy';
import './i18n';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LicenseInfo } from '@mui/x-license';
import theme from './themes/baseTheme/theme';

LicenseInfo.setLicenseKey(import.meta.env.REACT_APP_MUI_PRO_LICENSE_KEY);

const root = createRoot(document.getElementById('root') as HTMLElement);

const renderApp = () => {
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <StyledEngineProvider injectFirst>
          <CssVarsProvider theme={extendTheme(theme)}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <App />
            </LocalizationProvider>
          </CssVarsProvider>
        </StyledEngineProvider>
      </Provider>
    </React.StrictMode>,
  );
};

if (import.meta.env.REACT_APP_ENABLE_MOCK_API === 'true' && import.meta.env.DEV) {
  import('./mocks/browser')
    .then((apiMock) =>
      apiMock.worker
        .start({
          onUnhandledRequest(request, print) {
            const url = new URL(request.url);
            const whiteList = [
              '/static',
              '/bff',
              '/main.',
              '/api/',
              '/app-links',
              '/app-configuration',
              'src_mocks_browser_ts.',
              '/src/themes',
              '/node_modules',
              '/assets/',
            ];
            const shouldSuppressWarning = whiteList.some((pathStart) =>
              url.pathname.startsWith(pathStart),
            );
            if (shouldSuppressWarning) {
              return;
            }
            print.warning();
          },
        })
        .then(() => renderApp()),
    )
    .catch((error) => console.error(error));
} else {
  renderApp();
}
